import React from 'react';

// Импортируем иконки (файл помещен в папку components/assets/icons)
// Фактически вы можете использовать иконки из библиотеки lucide-react
// или создать свои собственные SVG-иконки

const WhyUsSection = () => {
    const advantageItems = [
        {
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#171717" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                    <polyline points="14 2 14 8 20 8"></polyline>
                    <line x1="16" y1="13" x2="8" y2="13"></line>
                    <line x1="16" y1="17" x2="8" y2="17"></line>
                    <polyline points="10 9 9 9 8 9"></polyline>
                </svg>
            ),
            title: 'Договор',
            description: 'Мы заключаем официальный договор.'
        },
        {
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#f97316" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"></circle>
                    <path d="M12 8v4l3 3"></path>
                </svg>
            ),
            title: 'Точные сроки',
            description: 'Работаем в соответствии с оговоренными в договоре сроками.'
        },
        {
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#171717" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                    <circle cx="9" cy="7" r="4"></circle>
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
            ),
            title: 'Опыт более 7-ми лет',
            description: 'Много лет на рынке, знаем все нюансы подбора и тонкости покупки автомобиля за границей.'
        },
        {
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#f97316" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9z"></path>
                    <polyline points="9 22 9 12 15 12 15 22"></polyline>
                </svg>
            ),
            title: 'Доставка из Европы',
            description: 'Пригон автомобилей из таких стран как Бельгия, Италия, Германия и др.'
        },
        {
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#171717" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="4" width="20" height="16" rx="2"></rect>
                    <path d="M2 10h20"></path>
                </svg>
            ),
            title: 'Выгодная цена услуг',
            description: 'Цена наших услуги  70 000 руб (перед оплатой составляем договор и работаем исключительно по договору)'
        },
        {
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#f97316" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"></path>
                    <line x1="4" y1="22" x2="4" y2="15"></line>
                </svg>
            ),
            title: 'Проверка авто',
            description: 'Проверка продавца и полной истории авто перед покупкой.'
        },
        {
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#171717" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                </svg>
            ),
            title: 'Авто по параметрам',
            description: 'Вы получите автомобиль с выбранными Вами характеристиками.'
        },
        {
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#f97316" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
                </svg>
            ),
            title: 'Оформление авто',
            description: 'Самостоятельно занимаемся таможенным оформлением и помогаем с постановкой на учет в ГИБДД'
        }
    ];

    return (
        <div className="why-us-section">
            <h2 className="why-us-title">Почему мы?</h2>

            <p className="why-us-description">
                У нас большой опыт в проверке и доставке авто из Германии, Италии, Бельгии, Франции, Нидерландов
                и других стран Западной Европы. Мы знаем как сохранить деньги и купить качественный автомобиль.
            </p>

            <div className="advantages-grid">
                {advantageItems.map((item, index) => (
                    <div className="advantage-item" key={index}>
                        <div className="advantage-icon">
                            {item.icon}
                        </div>
                        <h3 className="advantage-title">{item.title}</h3>
                        <p className="advantage-description">{item.description}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default WhyUsSection;
